export default __webpack_public_path__ + "static/media/carousel-img-7.0a619335.png";